import {
  DeployContractPackageResult,
  FtTokenMarketData,
  TokenMarketData,
} from '@block-explorer/entities';
import { ChainNames } from '../domain';

enum DexTrades {
  CSPR_TRADE = 1,
}

const findByDexId = (
  dexId: DexTrades,
  tradeData: TokenMarketData[]
): TokenMarketData | undefined => {
  return tradeData?.find((data) => data.dex_id === dexId);
};

const getCsprTradeWebsiteUrl = (
  contractPackageHash: string | undefined | null
): string => {
  const websiteUrl =
    config.network_name === ChainNames.MAINNET
      ? 'https://cspr.trade'
      : 'https://testnet.cspr.trade';

  return contractPackageHash
    ? `${websiteUrl}/token-details/${contractPackageHash}`
    : websiteUrl;
};

export const deriveFtTokenMarketDataService = (
  contractPackageInfo: DeployContractPackageResult | undefined | null
): FtTokenMarketData => {
  if (!contractPackageInfo) {
    return {
      price: null,
      token_volume_24h: null,
      volume_24h: null,
      iconPath: null,
      website: null,
    };
  }

  const tradeData = contractPackageInfo?.token_market_data ?? [];
  const csprTrade = findByDexId(DexTrades.CSPR_TRADE, tradeData);

  if (csprTrade) {
    return {
      iconPath: 'assets/icons/ic-cspr-trade-dex.svg',
      website: getCsprTradeWebsiteUrl(
        contractPackageInfo?.contract_package_hash
      ),
      label: 'CSPR.trade',
      price: csprTrade.latest_rate,
      volume_24h: csprTrade.volume_24h,
    };
  }

  return {
    price: null,
    token_volume_24h: null,
    volume_24h: null,
    iconPath: null,
    website: null,
  };
};

export default deriveFtTokenMarketDataService;
